import { withI18n } from 'panda-i18n';
import locale from "../../locales";
import { CnDepartmentSelect as UICnDepartmentSelect } from './department-select';
export var CnDepartmentSelect = withI18n(UICnDepartmentSelect, {
    locale: locale,
});
